import { create } from 'zustand';

interface LayoutModalStore {
  isLayoutModalOpen: boolean;
  openLayoutModal: () => void;
  closeLayoutModal: () => void;
  toggleLayoutModal: () => void;
}

export const useLayoutModalStore = create<LayoutModalStore>(set => ({
  isLayoutModalOpen: false,
  openLayoutModal: () => set({ isLayoutModalOpen: true }),
  closeLayoutModal: () => set({ isLayoutModalOpen: false }),
  toggleLayoutModal: () => set(state => ({ isLayoutModalOpen: !state.isLayoutModalOpen })),
}));
